export default {
  default: () => import("/vercel/path0/node_modules/adificial-base-layer/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/vercel/path0/node_modules/adificial-base-layer/layouts/empty.vue").then(m => m.default || m)
}